/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const SingleMedia = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 13 15">
      <path d="M2.35610526,0.564855151 C2.04810526,0.376876177 1.66210526,0.374876401 1.35010526,0.550856717 C1.03610526,0.728836809 0.842105263,1.06279945 0.842105263,1.42275919 L0.842105263,13.4214171 C0.842105263,13.7793771 1.03610526,14.1133397 1.35010526,14.2913198 C1.50210526,14.3773102 1.67210526,14.4213053 1.84210526,14.4213053 C2.02010526,14.4213053 2.19810526,14.3733106 2.35610526,14.2793211 L12.3561053,8.27999219 C12.6581053,8.10001232 12.8421053,7.77404878 12.8421053,7.42208815 C12.8421053,7.07012752 12.6581053,6.74416398 12.3561053,6.56418411 L2.35610526,0.564855151 Z" />
    </BaseSvgIcon>
  )
}

export default SingleMedia
